import { useSelector } from 'react-redux';

import { CustomerInformationCard } from '@makemydeal/dr-sales-checkin-components';
import { FINANCING_TITLE } from '@makemydeal/dr-sales-checkin-types';
import { getFinancingInitialTab } from '@makemydeal/dr-sales-checkin-store';

/**
 * SciFinancingCustomerCard — the financing flow's customer card.
 *
 * Renders the shared, store-backed `CustomerInformationCard` with the financing title passed as its
 * `heading`. The card owns everything else: it resolves the deal id + SPD capability and
 * reconciles saved values back into SCI state via `useSCICustomerCard`, and renders its own "Save"
 * footer. `onClose` is omitted (embedded mode → no Cancel), and `hideLoader` lets the disabled Save
 * button surface saving.
 *
 * The "Insurance" left-nav item redirects here with the financing slice set to 'insurance', so the
 * card opens on the buyer's Insurance sub-tab; any other entry opens on the buyer.
 */
const SciFinancingCustomerCard = () => {
    const financingInitialTab = useSelector(getFinancingInitialTab);

    return (
        <CustomerInformationCard
            heading={FINANCING_TITLE}
            customer="buyer"
            initialTab={financingInitialTab}
            hideLoader
            saveLabel="Save"
            showSaveSuccessBanner
            showSaveLoader
        />
    );
};

export default SciFinancingCustomerCard;
